import { post } from '@/utils/request'

/**
 * 帮助中心文章增加
 * @param {String} asid asid
 * @param {String} ls_id ls_id 分类id
 * @param {String} title 文章标题
 * @param {String} author 文章作者
 * @param {String} content 文章内容
 */
export function admin_help_article_add(data) {
  return post('admin_help_article_add', data)
}

/**
 * 帮助中心文章删除
 * @param {String} asid asid
 * @param {String} id id
 */
export function admin_help_article_delete(data) {
  return post('admin_help_article_delete', data)
}

/**
 * 帮助中心文章增加
 * @param {String} asid asid
 * @param {String} id 修改的菜单id
 * @param {String} ls_id ls_id 分类id
 * @param {String} title 文章标题
 * @param {String} author 文章作者
 * @param {String} content 文章内容
 */
export function admin_help_article_edit(data) {
  return post('admin_help_article_edit', data)
}

/**
 * 帮助中心文章列表
 * @param {String} asid asid
 * @param {String} ls_id ls_id
 * @param {String} page 
 * @param {String} pagesize 
 */
export function admin_help_article_list(data) {
  return post('admin_help_article_list', data)
}

/**
 * 帮助中心文章详情
 * @param {String} asid asid
 * @param {String} id ls_id
 */
export function admin_help_article_view(data) {
  return post('admin_help_article_view', data)
}

/**
 * 帮助中心菜单增加
 * @param {String} asid asid
 * @param {String} title
 * @param {String} cat_id
 */
export function admin_help_menu_add(data) {
  return post('admin_help_menu_add', data)
}

/**
 * 帮助中心菜单删除
 * @param {String} asid asid
 * @param {String} id
 */
export function admin_help_menu_delete(data) {
  return post('admin_help_menu_delete', data)
}

/**
 * 帮助中心菜单修改
 * @param {String} asid asid
 * @param {String} id
 * @param {String} title 菜单名称
 */
export function admin_help_menu_edit(data) {
  return post('admin_help_menu_edit', data)
}

/**
 * 帮助中心菜单列表
 * @param {String} asid asid
 */
export function admin_help_menu_list(data) {
  return post('admin_help_menu_list', data)
}